
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.572 6.167a1.93 1.93 0 000-2.726L5.527 1.398a1.928 1.928 0 00-2.726 0L1.68 2.52a2.886 2.886 0 00-.367 3.638 44.816 44.816 0 0012.529 12.528 2.89 2.89 0 003.638-.364L18.6 17.2a1.925 1.925 0 000-2.726l-2.043-2.044a1.927 1.927 0 00-2.726 0l-.682.682A45.73 45.73 0 016.89 6.85l.682-.683z"}})])
          )
        }
      }
    